import { BasicFilter, FilterType } from "./../../filters.d";
import { TagsField } from "./tags.form";

export const TAGS_FILTERS: BasicFilter[] = [
  {
    id: TagsField.Project,
    label: "Projekt",
    type: FilterType.Project,
  },
  {
    id: TagsField.Language,
    label: "Wersja językowa",
    type: FilterType.Language,
  },
  {
    id: TagsField.Name,
    label: "Nazwa",
    type: FilterType.Text,
  },
  {
    id: TagsField.CreatedAt,
    label: "Data utworzenia",
    type: FilterType.Date,
  },
  {
    id: TagsField.IsVisible,
    label: "Widoczność",
    type: FilterType.Boolean,
  },
];
